/* eslint-disable react/prop-types */
import React, { memo } from "react";
import ImageContainer from "components/ImageContainer";

export const ImageItem = memo(
  function ImageItem({
    image,
    index,
    isSelected,
    handlePickImage,
    onLoadSelected,
    showStatus
  }) {
    return (
      <ImageContainer
        id={image.sourceId}
        index={index}
        handlePickImage={handlePickImage}
        url={image.url}
        issue={image.issue}
        qualityData={image.qualityData}
        status={image.status}
        showStatus={showStatus}
        rotation={image?.metadata?.imageRotationDirection || 1}
        onLoad={() => {
          if (isSelected) onLoadSelected();
        }}
      />
    );
  },
  // prevent rerender
  (prev, next) => {
    return prev.image === next.image && prev.isSelected === next.isSelected;
  },
);
